module.exports = __webpack_public_path__ + "static/media/yosemite.aeccc830.jpg";